import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import { useEffect } from "react";

export default function Disclaimer() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
 
    return (
        <section className="min-h-screen bg-appBg dark:bg-appDark py-4 px-6">

            <div className="max-w-6xl mx-auto">

                {/* TITLE */}
                <h1 className="text-4xl md:text-5xl font-bold text-titleLight dark:text-titleDark mb-10">
                    Disclaimer
                </h1>

                {/* CONTENT BOX */}
                <div className="bg-card dark:bg-cardDark rounded-[28px] border border-borderLight dark:border-borderDark p-10 shadow-lg">

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        The information and services provided on{" "}
                        <Link to="/" className="text-primary underline">
                            Online-Clipboard.in
                        </Link>{" "}
                        are intended for general informational and utility purposes only. While we aim to provide a fast and reliable experience, we do not guarantee that the service will always be error-free, secure, or uninterrupted.
                    </p>

                    {/* NO GUARANTEES */}
                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        No Guarantees
                    </h3>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        We make no warranties or guarantees regarding the accuracy, completeness, or reliability of the service. The platform is provided "as is" without any express or implied warranties.
                    </p>

                    {/* RISK */}
                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        Use at Your Own Risk
                    </h3>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        Any action you take using this website is strictly at your own risk. We are not responsible for any losses, damages, or issues that may arise from using this service.
                    </p>

                    {/* DATA */}
                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        Data Usage Disclaimer
                    </h3>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        Users are strongly advised not to share sensitive or confidential information such as passwords, personal data, or financial details through this platform. Although we follow standard security practices, no online service can guarantee complete security.
                    </p>

                    {/* EXTERNAL */}
                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        External Links
                    </h3>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        Our website may contain links to third-party websites. We do not control or take responsibility for the content, privacy policies, or practices of these external sites.
                    </p>

                    {/* AVAILABILITY */}
                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        Service Availability
                    </h3>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        We do not guarantee uninterrupted access to the service. The website may be temporarily unavailable due to maintenance, updates, or technical issues beyond our control.
                    </p>

                    {/* CONSENT */}
                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        Consent
                    </h3>

                    <p className="text-textMain dark:text-textDark leading-8">
                        By using this website, you agree to this disclaimer and its terms. If you do not agree, you should discontinue using the service.
                    </p>

                </div>

                <Footer />

            </div>

        </section>
    );
}